import { render, staticRenderFns } from "./punch.vue?vue&type=template&id=1cde1c03&scoped=true"
import script from "./punch.vue?vue&type=script&lang=js"
export * from "./punch.vue?vue&type=script&lang=js"
import style0 from "./punch.vue?vue&type=style&index=0&id=1cde1c03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde1c03",
  null
  
)

export default component.exports